import { render, staticRenderFns } from "./amrContainersData.vue?vue&type=template&id=5277affd&"
import script from "./amrContainersData.vue?vue&type=script&lang=js&"
export * from "./amrContainersData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports